import { scrollTop } from '../utilities/scroll';

export default class {
  constructor({
    handle,
    anchorSelector
  }) {
    const anchorItems = document.querySelectorAll(anchorSelector);

    const handleDrawerSlide = (item) => {
      const targetEl = document.querySelector('#' + item.getAttribute('data-target'));
      scrollTop(targetEl, 100);
      setTimeout(() => {
        targetEl.querySelector('input').checked = true;
      }, 500);
    }

    Array.from(anchorItems).forEach(item => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        handleDrawerSlide(item);
      })
    });
  }
}